import BaseApi from './baseApi';
import ISells from '../models/ISells';
import IAuthentication from '../models/IAuthentication';
import { EMPTY_GUID } from '../../config/constants';
export default class SellApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Sells");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async CompleteSell(idSell: string) : Promise<boolean> {
        let json : string = this.getJsonCompleteSell(idSell);
        const response = await this.api.post('exec', json);
        return this.isSuccess(response);
    }

    async GetSells(idCompany: string) : Promise<ISells[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithIdCompany(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var sells: ISells[] = [];
            sells = response.data as ISells[];
            return sells;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetSellById(idSell: string) : Promise<ISells> {
        let json : string = "";
        json = this.getJsonReadWithIdSell(idSell);
        const response = await this.api.post('read', json);
        if (!response) return {} as ISells;
        if (response.isSuccess) {
            var sell: ISells = {} as ISells;
            sell = response.data as ISells;
            return sell;
        } else {
            this.modelState = response.errorState;
            return {} as ISells;
        }
    }

    async GetSellsCompleted(idCompany: string) : Promise<ISells[]> {
        let json : string = "";
        if (idCompany === EMPTY_GUID) {
            json = this.getJsonRead();
        } else {
            json = this.getJsonReadWithOnlyCompleted(idCompany);
        }
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var sells: ISells[] = [];
            sells = response.data as ISells[];
            return sells;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveSell(sell: ISells) : Promise<string> {
        const json = this.getJsonSave(sell);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateSell(sell: ISells) : Promise<boolean> {
        const json = this.getJsonUpdate(sell);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteSell(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonCompleteSell(idSell: string): any {
        const json = {
            "spname": "dbo.create_sell",
            "parameters": [{
                "Item1": "IdSell",
                "Item2": idSell
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "sells",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "sells"
        };
        return json;
    }

    private getJsonSave(sell: ISells) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": sell.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": sell.idCompanyDestination
            }, {
                "Item1": "idCustomerSource",
                "Item2": sell.idCustomerSource
            }, {
                "Item1": "idCustomerDestination",
                "Item2": sell.idCustomerDestination
            }, {
                "Item1": "idListStatusSell",
                "Item2": sell.idListStatusSell
            }, {
                "Item1": "inboundCodeDestination",
                "Item2": sell.inboundCodeDestination
            }, {
                "Item1": "inboundCodeSource",
                "Item2": sell.inboundCodeSource
            }, {
                "Item1": "dateSell",
                "Item2": sell.dateSell
            }, {
                "Item1": "description",
                "Item2": sell.description
            }, {
                "Item1": "orderNumber",
                "Item2": sell.orderNumber
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "sells"
        };
        return json;
    }

    private getJsonUpdate(sell: ISells) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idCompanySource",
                "Item2": sell.idCompanySource
            }, {
                "Item1": "idCompanyDestination",
                "Item2": sell.idCompanyDestination
            }, {
                "Item1": "idCustomerSource",
                "Item2": sell.idCustomerSource
            }, {
                "Item1": "idCustomerDestination",
                "Item2": sell.idCustomerDestination
            }, {
                "Item1": "idListStatusSell",
                "Item2": sell.idListStatusSell
            }, {
                "Item1": "inboundCodeDestination",
                "Item2": sell.inboundCodeDestination
            }, {
                "Item1": "inboundCodeSource",
                "Item2": sell.inboundCodeSource
            }, {
                "Item1": "dateSell",
                "Item2": sell.dateSell
            }, {
                "Item1": "description",
                "Item2": sell.description
            }, {
                "Item1": "orderNumber",
                "Item2": sell.orderNumber
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "sells",
            "keyvalue": sell.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "sells",
                "Item2": "id"
            }, {
                "Item1": "sells",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerSource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerSource) as customerSourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerDestination) as customerDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusSell where id = idListStatusSell) as statusName"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeDestination"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeSource"
            }, {
                "Item1": "sells",
                "Item2": "dateSell"
            }, {
                "Item1": "sells",
                "Item2": "description"
            }, {
                "Item1": "sells",
                "Item2": "orderNumber"
            }],
            "tables": [{
                "Item1": "sells"
            }],
            "conditions": [{
                "Item1": "sells",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusSell WHERE Name = 'Completed')"
            }]
        };
        return json;
    }

    private getJsonReadWithIdCompany(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "sells",
                "Item2": "id"
            }, {
                "Item1": "sells",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerSource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerSource) as customerSourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerDestination) as customerDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusSell where id = idListStatusSell) as statusName"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeDestination"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeSource"
            }, {
                "Item1": "sells",
                "Item2": "dateSell"
            }, {
                "Item1": "sells",
                "Item2": "description"
            }, {
                "Item1": "sells",
                "Item2": "orderNumber"
            }],
            "tables": [{
                "Item1": "sells"
            }],
            "conditions": [{
                "Item1": "sells",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell",
                "Item3": "NOT IN",
                "Item4": "(SELECT ID FROM ListStatusSell WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(sells",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "sells",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }

    private getJsonReadWithIdSell(idSell: string) : any {
        const json = {
            "fields": [{
                "Item1": "sells",
                "Item2": "id"
            }, {
                "Item1": "sells",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerSource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerSource) as customerSourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerDestination) as customerDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusSell where id = idListStatusSell) as statusName"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeDestination"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeSource"
            }, {
                "Item1": "sells",
                "Item2": "dateSell"
            }, {
                "Item1": "sells",
                "Item2": "description"
            }, {
                "Item1": "sells",
                "Item2": "orderNumber"
            }],
            "tables": [{
                "Item1": "sells"
            }],
            "conditions": [{
                "Item1": "sells",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "sells",
                "Item2": "id",
                "Item3": "=",
                "Item4": idSell
            }]
        };
        return json;
    }

    private getJsonReadWithOnlyCompleted(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "sells",
                "Item2": "id"
            }, {
                "Item1": "sells",
                "Item2": "idCompanySource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanySource) as companySourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Companies where id = IdCompanyDestination) as companyDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerSource"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerSource) as customerSourceName"
            }, {
                "Item1": "sells",
                "Item2": "idCustomerDestination"
            }, {
                "Item1": "",
                "Item2": "(select Name from Customers where id = IdCustomerDestination) as customerDestinationName"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell"
            }, {
                "Item1": "",
                "Item2": "(select Name from ListStatusSell where id = idListStatusSell) as statusName"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeDestination"
            }, {
                "Item1": "sells",
                "Item2": "inboundCodeSource"
            }, {
                "Item1": "sells",
                "Item2": "dateSell"
            }, {
                "Item1": "sells",
                "Item2": "description"
            }, {
                "Item1": "sells",
                "Item2": "orderNumber"
            }],
            "tables": [{
                "Item1": "sells"
            }],
            "conditions": [{
                "Item1": "sells",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "sells",
                "Item2": "idListStatusSell",
                "Item3": "IN",
                "Item4": "(SELECT ID FROM ListStatusSell WHERE Name = 'Completed')",
                "Item5": "AND"
            }, {
                "Item1": "(sells",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "sells",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }]
        };
        return json;
    }
}
